FNC.Menu.headergrid = _=> {
    let header = document.querySelector("body>header");
    let grid = document.querySelector(".header.grid");
    if(grid) grid.style.height = header.offsetHeight + "px";
}

FNC.Menu.init =  _=> {
    let breaker = parseInt(FN.getCSSVar(document.body, "--break-lg-end")) - 16;
    let items = document.querySelectorAll("#categories>li");

    let resetOrder = _=> {
        if(_=window.currentCategoryItem) _.style.removeProperty("order");
        delete window.currentCategoryItem;
    }

    let enhanceRadios = radios => {
        if(!radios || !radios.length) return;
        radios[0].nextElementSibling.onmouseup = function(e) {
            let radio = e.target.previousElementSibling;
            let deselect = checked => {
                radio.checked = !checked;
                if(checked) resetOrder();
            }
            if(radio) setTimeout(deselect, 0, radio.checked);
        }
        radios[0].onclick = _ => {
            resetOrder();
            if(document.body.offsetWidth > breaker) return;
            let li = radios[0].parentNode;
            li.style.order = -1;
            window.currentCategoryItem = li;
            li.querySelector("div").style.width = li.offsetWidth + "px";
        }
        radios[1].onclick = _ => {
            if(!window.currentCategoryItem) return;
            resetOrder();
            ID.burgerIcon.checked = false;
        }
    }

    let enhanceHover = a => a.onmouseenter = _ => {
        if(document.body.offsetWidth <= breaker) return;
        let grandpa = a.parentNode.parentNode.querySelector("div");
        if(grandpa) grandpa.style.removeProperty("width");
        a.parentNode.previousElementSibling.checked = true;
    }

    let enhanceUnhover = div => div.onmouseleave = _ => {
        if(document.body.offsetWidth <= breaker) return;
        div.previousElementSibling.previousElementSibling.checked = false;
    }

    items.forEach(item => enhanceRadios(item.querySelectorAll(".switch")));
    items.forEach(item => (item=item.querySelector("label a")) && enhanceHover(item));
    items.forEach(item => (item=item.querySelector("label+div")) && enhanceUnhover(item));
    headerCurtain.addEventListener("click", _=> ID.burgerIcon.checked = false);

    let fathers = document.querySelectorAll("#categories .father");
    let fold = father => {
        father.parentNode.parentNode.style.overflow = "hidden";
        father.parentNode.parentNode.parentNode.style.top = 0;
        father.nextElementSibling.style.cssText = "display: flex !important; position: absolute; top: 0; min-height: 100%;";
        father.nextElementSibling.firstElementChild.style.cssText = "margin-top: 50px";
        father.previousElementSibling.style.cssText = "display: block";
    }
    let unfold = father => {
        father.parentNode.parentNode.style.overflow = "";
        father.parentNode.parentNode.parentNode.style.top = "50px";
        father.nextElementSibling.style.cssText = "";
        father.nextElementSibling.firstElementChild.style.cssText = "";
        father.previousElementSibling.style.cssText = "";
    }
    fathers.forEach(father => father.onclick = e => {
        if(document.body.offsetWidth > breaker) return;
        e.preventDefault();
        fold(father);
    });
    fathers.forEach(father => father.previousElementSibling.onclick = e => {
        if(document.body.offsetWidth > breaker) return;
        e.preventDefault();
        unfold(father);
    });
    let cleanStyles = _=> document.querySelectorAll("#categories [style]").forEach(el => el.removeAttribute("style"));
    ID.burgerIcon.addEventListener("change", e => !e.target.checked && cleanStyles());
    headerCurtain.addEventListener("click", cleanStyles);
    document.querySelectorAll("#categories .curtain").forEach(el => el.addEventListener("click", cleanStyles));
    FNC.Menu.headergrid();
}

addEventListener("resize", FNC.Menu.headergrid);
addEventListener("DOMContentLoaded", FNC.Menu.init);